import {
    Chart as ChartJS,
    LineElement,
    PointElement,
    CategoryScale,
    LinearScale,
    Filler,
    Tooltip,
    Legend
} from 'chart.js';
import { Line } from 'react-chartjs-2'
import { MwSpinnerButton } from '../ui';

ChartJS.register(
    LineElement,
    PointElement,
    CategoryScale,
    LinearScale,
    Filler,
    Tooltip,
    Legend
)

const LineChart = ({ label, datasetData, loading, className }) => {
    const data = {
        labels: ['يناير', 'فبراير', 'مارس', 'ابريل', 'مايو', 'يونيو', 'يوليو', 'اغسطس', 'سمبتمبر', 'اكتوبر', 'نوفمبر', 'ديسمبر'],
        datasets: [
            {
                label: label,
                data: datasetData,
                borderColor: '#3D3B40',
                backgroundColor: 'rgba(61, 59, 64, 0.1)',
                fill: true,
                tension: 0.4,
                pointBackgroundColor: '#3D3B40',
                pointBorderColor: '#fff',
                pointHoverRadius: 6,
            }
        ]
    }
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'top',
                labels: {
                    font: {
                        size: 14,
                        family: '"Tajawal", sans-serif',
                    }
                }
            }
        },
        scales: {
            y: {
                beginAtZero: true,
                grid: {
                    color: 'rgba(0, 0, 0, 0.05)',
                }
            },
            x: {
                grid: {
                    display: false,
                }
            }
        }
    }

    return (
        <div className='relative w-full h-full min-h-[300px]'>
            {!loading ? (
                <Line
                    className={className}
                    data={data}
                    options={options}
                />
            ) : (
                <MwSpinnerButton withLabel={false} isFullCenter={true} />
            )}
        </div>
    )
}

export default LineChart
